import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';
import {
  shouldDirectToCouponAfterKawanClaim,
  shouldNavigateToCouponDetails,
} from '../navigation/navigateToClaimedCoupon';
import { isPointsScanSuccessWithoutCoupon } from '../utils/scanClaimUi';

export default function ScanSuccessNextActions({
  scanResult,
  loading = false,
  primaryColor = '#222',
  onPrimary,
  onLihatPoin,
}) {
  const showPointsActions = isPointsScanSuccessWithoutCoupon(scanResult);
  const primaryLabel = loading
    ? 'Memeriksa...'
    : scanResult?.type === 'invalid'
      ? 'Try Again'
      : shouldDirectToCouponAfterKawanClaim(scanResult)
        ? 'Lihat Detail Kupon'
        : shouldNavigateToCouponDetails(scanResult)
          ? 'Lihat Kupon'
          : showPointsActions
            ? 'Scan lagi'
            : 'Continue';

  return (
    <View style={styles.wrap}>
      <TouchableOpacity
        style={[styles.primary, { backgroundColor: primaryColor }, loading && styles.disabled]}
        onPress={onPrimary}
        disabled={loading}
      >
        <Text style={styles.primaryText}>{primaryLabel}</Text>
      </TouchableOpacity>
      {showPointsActions ? (
        <TouchableOpacity
          style={[styles.secondary, loading && styles.disabled]}
          onPress={onLihatPoin}
          disabled={loading}
        >
          <Text style={styles.secondaryText}>Tukar Poin</Text>
        </TouchableOpacity>
      ) : null}
    </View>
  );
}

const styles = StyleSheet.create({
  wrap: {
    marginHorizontal: 16,
    marginBottom: 16,
    gap: 10,
  },
  primary: {
    paddingVertical: 12,
    borderRadius: 12,
    alignItems: 'center',
  },
  primaryText: {
    color: '#FFFFFF',
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '500',
    fontFamily: 'Poppins-Medium',
  },
  secondary: {
    paddingVertical: 12,
    borderRadius: 12,
    alignItems: 'center',
    backgroundColor: '#F8F9FA',
    borderWidth: 1,
    borderColor: '#DDDDDD',
  },
  secondaryText: {
    color: '#0F172A',
    fontSize: 14,
    lineHeight: 20,
    fontWeight: '500',
    fontFamily: 'Poppins-Medium',
  },
  disabled: {
    opacity: 0.8,
  },
});
